import {
  IX_SITE_ID,
  PUBMATIC_PUBLISHER_ID,
  RUBICON_ACCOUNT_ID,
  RUBICON_SITE_ID,
  RUBICON_ZONE_ID,
  UNDERDOG_SITE_ID,
  OPENX_UNIT_ID,
  OPENX_DOMAIN,
  adUnitAlias,
  adUnitAliasToPath,
  MEDIANET_CID,
  MEDIANET_CRID,
} from '../../constants'
import logBase from '../../utils/logger'

const log = logBase.extend('PREBID')

const getPartnersBids = (unitPath: adUnitAlias) => {
  return {
    partners: {
      ix: {
        params: {
          siteId: IX_SITE_ID[unitPath],
        },
      },
      pubmatic: {
        params: {
          publisherId: PUBMATIC_PUBLISHER_ID,
        },
      },
      rubicon: {
        params: {
          accountId: RUBICON_ACCOUNT_ID,
          siteId: RUBICON_SITE_ID,
          zoneId: RUBICON_ZONE_ID[unitPath],
          position: 'atf', // above the fold
        },
      },
      underdogmedia: {
        params: {
          siteId: UNDERDOG_SITE_ID[unitPath],
        },
      },
      openx: {
        params: {
          unit: OPENX_UNIT_ID[unitPath],
          delDomain: OPENX_DOMAIN,
        },
      },
      medianet: {
        params: {
          cid: MEDIANET_CID,
          crid: MEDIANET_CRID[unitPath],
        },
      },
    },
  }
}
export const partnersConfig = {
  config: {
    userSync: {
      iframeEnabled: true,
      filterSettings: {
        iframe: {
          bidders: '*', // '*' represents all bidders
          filter: 'include',
        },
      },
    },
  },
  bidderSettings: {
    ix: {
      storageAllowed: true,
    },
  },
}

export const buildPrebidPartnersBids = (unitPath: adUnitAlias) => {
  log('Building partners config...')

  if (!Object.values(adUnitAliasToPath).includes(unitPath)) {
    throw new Error(`Invalid unit path ID: ${unitPath}`)
  }

  const bids = []
  const { partners } = getPartnersBids(unitPath)

  for (const [partner, { params }] of Object.entries(partners)) {
    bids.push({
      bidder: partner,
      params,
    })
  }

  return { bids }
}
